<main>
	@for (fieldsBlock of fields; track fieldsBlock; let i = $index) {
		@if (fieldsBlock.enabled) {
			<div class="flex w-full">
				<div class="inline-flex items-center mb-[12px]">
					@if (fieldsBlock.required) {
						<div
							class="h-1 w-1 rounded ml-[8px] mr-[8px]"
							[class.bg-primary]="fieldsBlock.error.length === 0 && !fieldsBlock.filled"
							[class.bg-gray-600]="fieldsBlock.error.length === 0 && fieldsBlock.filled"
							[class.bg-error]="fieldsBlock.error.length > 0"
						></div>
					}
					<p class="text-font text-xs">{{ fieldsBlock.label }}</p>
					<a [id]="fieldsBlock.label"></a>
				</div>
			</div>
			<div class="ff-row-form overflow-x-hidden w-full">
				@for (row of fieldsBlock.fields; track row; let last = $last) {
					<div class="ff-row-form overflow-x-hidden">
						@for (field of row; track field) {
							<div class="ff-box-field" [ngClass]="'ff-field-size-' + field.size">
								@if (field.type === 'HIDDEN') {
									<lbca-input-hidden
										[label]="field.label"
										[defaultValue]="field.defaultValue"
									></lbca-input-hidden>
								}
								@if (field.type === 'TEXT') {
									<lbca-input-text
										[label]="field.label"
										[disabled]="field.disabled || isDisabled"
										[labeled]="true"
										[error]="field.error"
										[require]="field.required"
										[maskInput]="field.mask"
										(changeValue)="changeFieldValue($event, field.entityKey)"
										[value]="field.value ? field.value : ''"
									></lbca-input-text>
								}
								@if (field.auxEntity) {
									<lbca-entity-fields
										[forceType]="field.forceType || 'SELECT_ONE'"
										[inline]="true"
										[field]="field"
										[label]="field.label"
										[error]="field.error"
										[disabled]="isDisabled"
										[labeled]="true"
										[require]="field.required"
										[value]="field.value"
										[cardData]="cardInfo"
										(changeValue)="changeFieldValue($event, field.entityKey)"
									></lbca-entity-fields>
								}
								@if (field.type === 'CALENDAR') {
									<lbca-date-picker
										[label]="field.label"
										[disabled]="isDisabled"
										[labeled]="true"
										[error]="field.error"
										[require]="field.required"
										(changeValue)="changeFieldValue($event, field.entityKey)"
										[calendarPosition]="'top'"
										[value]="field.value"
										[rules]="field.rules"
										[disabledDateRules]="field.disabledDateRules"
									></lbca-date-picker>
								}
								@if (field.type === 'DATE_TIME') {
									<lbca-date-time-picker
										[labelDate]="field.labelDate"
										[labelTime]="field.labelTime"
										[require]="field.required"
										[error]="field.error"
										[value]="field.value"
										[rules]="field.rules"
										[disabledDateRules]="field.disabledDateRules"
										(changeValue)="changeFieldValue($event, field.entityKey)"
										[disabled]="isDisabled"
										[labeled]="true"
									></lbca-date-time-picker>
								}
							</div>
						}
						@if (i === 0 && !isDisabled) {
							<ng-template [ngTemplateOutlet]="controllers"></ng-template>
						}
						@if (i > 0 && last) {
							<div class="ff-box-field ff-field-size-1 flex items-center">
								<label (click)="toogle(fieldsBlock)" class="claim-trash-container">
									<div class="claim-trash"></div>
								</label>
							</div>
						}
					</div>
				}
			</div>
		}
	}
</main>

<ng-template #controllers>
	<div class="ff-box-field ff-field-size-1 flex justify-between items-center w-full">
		@for (fieldsBlock of fields; track fieldsBlock; let i = $index) {
			@if (i > 0) {
				<!--- Principal skip -->
				<div class="flex flex-row items-center">
					<label
						(click)="toogle(fieldsBlock)"
						class="shadow cursor-pointer rounded-full flex items-center justify-center p-[0px] h-[24px] w-6 min-w-6 text-2xl text-gray-50 transition duration-400 ease-in-out"
						[class.bg-primary]="!fieldsBlock.enabled"
						[class.bg-gray-600]="fieldsBlock.enabled"
						[class.cursor-not-allowed]="fieldsBlock.enabled"
					>
						<svg
							width="12"
							height="12"
							viewBox="0 0 12 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M5 5V0.666667C5.11111 0.444444 5.33333 0 6 0C6.66667 0 6.88889 0.444444 7 0.666667V5H11.3333C11.5556 5.11111 12 5.46667 12 6C12 6.53333 11.5556 6.88889 11.3333 7H7V11.3333C7 11.3333 6.66667 12 6 12C5.33333 12 5 11.3333 5 11.3333V7H0.666667C0.666667 7 0 6.66667 0 6C0 5.33333 0.666667 5 0.666667 5H5Z"
								fill="white"
							/>
						</svg>
					</label>
					<span
						(click)="toogle(fieldsBlock)"
						class="text-sm text-gray-700 ml-[5px]"
						[class.cursor-pointer]="!fieldsBlock.enabled"
						[class.cursor-not-allowed]="fieldsBlock.enabled"
					>
						{{ fieldsBlock.label }}
					</span>
				</div>
			}
		}
	</div>
</ng-template>
